//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import Table from "@/components/FilterTable/Table.vue";

const DEFAULT_FORMAT = value => (value ? value : "N/A");

export default {
  name: "SalesForceTable",
  props: ["tableClass", "bordered", "data", "recordsTotal", "loading"],
  components: {
    Table
  },
  mounted: function() {
    this.loadSellersHierarchy();
  },
  data: () => ({
    separator: "horizontal",
    salesForce: [],
    columns: [
      {
        name: "id",
        required: false,
        label: "#ID",
        align: "left",
        field: row => row.id,
        format: DEFAULT_FORMAT,
        sortable: false
      },
      {
        name: "level-number",
        required: false,
        align: "left",
        label: "Nº Nível",
        field: row => row.level_id,
        format: DEFAULT_FORMAT,
        sortable: false
      },
      {
        name: "classification-level",
        required: false,
        align: "left",
        label: "Classificação Nível",
        field: row => row.name,
        format: DEFAULT_FORMAT,
        sortable: false
      },
      {
        name: "classification-level-agregator",
        required: false,
        align: "left",
        label: "Classificação Nível Agregador",
        field: row => row.parent_id,
        format: DEFAULT_FORMAT,
        sortable: false
      },
      {
        name: "designation-level",
        required: false,
        align: "left",
        label: "Designação Nível",
        field: row => row.designationLevel,
        format: DEFAULT_FORMAT,
        sortable: false
      },
      {
        name: "designation-level-agregator",
        required: false,
        align: "left",
        label: "Designação Nível Agregador",
        field: row => row.designationLevelAgregator,
        format: DEFAULT_FORMAT,
        sortable: false
      }
    ],
    filteredData: []
  }),
  methods: {
    loadSellersHierarchy: function() {
      BackendServices.getSalesforceHierarchyLevelElements().then(response => {
        this.salesForce = response.data;
      });
    },
    renderRightSide: function(event) {
      this.$emit("clicked-row", { ...event });
    },
    updateFilter: function(event) {
      this.$emit("filter-changed", event);
    }
  }
};
